import { useQuery } from "@tanstack/react-query";
import tradeService from "../services/trade.service";
import { useParams } from "react-router-dom";
import TradesTable from "./uiElements/TradesTable.component";
import Loader from "./Spinner.component";
import { ListGroup } from "react-bootstrap";
import ErrorPage from "./ErrorPage.component";
import { useEffect } from "react";

function TickerTrades() {
  const { tickerName } = useParams();

  const { data, isLoading, error } = useQuery({
    queryKey: ["tickerTrades"],
    queryFn: async () => {
      try {
        const result = await tradeService.getTradesByTicker(tickerName);
        return result;
      } catch (error) {
        console.error("Error fetching ticker trades:", error);
        throw error;
      }
    },
  });

  if (isLoading) return <Loader />;

  if (error) return <ErrorPage errorCode="500" description="Something went wrong , please try again later" />;

  console.log(data, error);
  return (
    <div className="trade-table-container">
      <h3 className="mb-4">All ({tickerName}) Trades</h3>
      <hr />
      <div>
        <ListGroup>
          <ListGroup.Item className="fw-bold d-flex gap-4 p-3">
            <div>
              Total Ticker Profit/Loss :
              <span className={data?.totalProfit < 0 ? "text-danger" : "text-success"}> {data?.totalProfit} </span>
            </div>
          </ListGroup.Item>
          {/* <TradesTable type={"single"} trades={[trade]} /> */}
        </ListGroup>
      </div>
      <TradesTable trades={data?.trades} />
    </div>
  );
}

export default TickerTrades;
